import EventEmitter from "../../components/base/event-emitter";
import WidgetSearchField from "../../widgets/widget-search-field";
import EnvHelper from "../../lib/env-helper";
import Api from "../../lib/api";

export default class MobileSearchController extends EventEmitter {
    constructor() {
        super({});
        this.$field = document.getElementById('wikiMobileNavSearchField');
        this.$panel = document.getElementById('wikiMobileNavSearchPanel');
        this.$itemContainer = this.$panel.querySelector('.search-panel_item-list');

        this.searchField = new WidgetSearchField({
            $root: this.$field,
            activeStateOnFocus: true,
            dropStateOnAction: true
        });

        this.searchUrl = `${Api.apiSiteUrl}/feed/wiki/search`;
        this.value = '';

        this.FOCUS_SEARCH_INPUT_EVENT = 'focusSearchInput';
        this.ACTIVE_STATE_CHANGE_EVENT = 'activeStateChangeEvent';

        this.init();
    }

    init() {
        super.init();
        this.addEventListeners();
    }

    addEventListeners() {
        this.searchField.subscribe('activeState', () => {
            this.dispatchEvent(this.ACTIVE_STATE_CHANGE_EVENT, true);
        });

        this.searchField.subscribe('dropState', () => {
            this.dispatchEvent(this.ACTIVE_STATE_CHANGE_EVENT, false);
        });

        this.addSearchEventListener();
    }

    addSearchEventListener() {
        let timeoutId;

        this.searchField.subscribe('searchInput', ({ detail: value }) => {
            this.value = value;

            if (!this.value.length) {
                this.setState('initial');
                return;
            }

            this.setState('progress');

            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(() => {
                this.search();
            }, 500);
        });
    }

    setState(type) {
        this.$panel.dataset.active = type;
    }

    search() {
        const params = {
            query: this.value,
            lang: EnvHelper.siteLang
        };

        if (EnvHelper.page.entrySlug) {
            params.slug = EnvHelper.page.entrySlug;
        }

        Api.get(this.searchUrl, params)
            .then((data) => {
                if (data && data.trim()) {
                    this.$itemContainer.innerHTML = data.trim();
                    this.setState('result');
                } else {
                    this.setState('error');
                }
            });
    }
}